package fr.manyverse.app.infrastructure.repository

import fr.manyverse.app.domain.repository.RealtimeConnectionRepository
import fr.manyverse.app.infrastructure.realtime.reconnections
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.realtime.Realtime
import io.github.jan.supabase.realtime.RealtimeChannel
import io.github.jan.supabase.realtime.realtime
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.withTimeoutOrNull
import kotlin.time.Duration.Companion.seconds

// Un channel rejeté par le serveur ne se réabonne jamais : on n'attend pas indéfiniment
private val RESUBSCRIBE_TIMEOUT = 10.seconds

class SupabaseRealtimeConnectionRepository(
    private val supabaseClient: SupabaseClient
) : RealtimeConnectionRepository {

    override fun observeReconnections(): Flow<Unit> =
        reconnections(
            isConnected = supabaseClient.realtime.status.map { it == Realtime.Status.CONNECTED },
            awaitResubscribed = ::awaitChannelsResubscribed
        )

    /**
     * supabase-kt réabonne les channels juste après la reconnexion. Recharger avant ferait perdre
     * les changements survenus entre la lecture et le réabonnement.
     */
    private suspend fun awaitChannelsResubscribed() {
        withTimeoutOrNull(RESUBSCRIBE_TIMEOUT) {
            supabaseClient.realtime.subscriptions.values.forEach { channel ->
                channel.status.first { it == RealtimeChannel.Status.SUBSCRIBED }
            }
        }
    }
}
